"use client"

export default function Error({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="content-container flex min-h-[60vh] flex-col items-center justify-center gap-4 py-16 text-center">
      <h2 className="font-display text-2xl font-bold">Щось пішло не так</h2>
      <p className="text-sm text-slate-500">
        Не вдалося завантажити сторінку. Спробуйте ще раз — якщо помилка повториться, напишіть у Telegram-підтримку.
      </p>
      <button
        onClick={reset}
        className="rounded-xl bg-brand-light px-6 py-2 text-sm font-semibold text-white dark:bg-brand-dark dark:text-slate-950"
      >
        Спробувати ще раз
      </button>
    </div>
  )
}
